import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import Loader from 'router/Loader';

const InitializePassword = Loader(
  lazy(() => import('content/pages/Guest/InitializePassword')),
);
const ResetPassword = Loader(
  lazy(() => import('content/pages/Guest/ResetPassword')),
);
const RequestResetPassword = Loader(
  lazy(() => import('content/pages/Guest/RequestResetPassword')),
);

const passwordRouter: RouteObject[] = [
  {
    path: 'initialize-password',
    element: <InitializePassword />,
  },
  {
    path: 'reset-password',
    element: <ResetPassword />,
  },
  {
    path: 'request-password-reset',
    element: <RequestResetPassword />,
  },
];

export default passwordRouter;
